import type { FaireProductEntity } from "../../entity_types/product";

export const p_paayf33698: FaireProductEntity = {
  token: "p_paayf33698",
  type: "product",
  name: "Zesty Jalapeno Kettle Cooked Potato Chips",
  brandToken: "b_7czabpidt2",
  brandName: "Deep River Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/012fc8d35863deac6bdeb8055d01ea7af3e942b65e89f7cd8820cf7fe2a48e6b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36ba4528c012681b609df389c006b870e71023601c5aec9347e0381a7ee77e4d.png",
    "https://cdn.faire.com/fastly/433565efdf911a6c0a968d6c1425555f7cd23a3a3e7fcb66ab6368633f7a8ac7.png",
  ],
  priceDollars: 41.56,
  description:
    "Four-alarm kick with only four ingredients! Impossibly simple and incredibly delicious, our Zesty Jalapeño kettle cooked chips are the perfect balance of flavor and fire.",
  tags: [],
  msrpDollars: 83.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:27.076Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
